exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pf-c-avatar {\n  --pf-c-avatar--BorderRadius: var(--pf-global--BorderRadius--lg);\n  --pf-c-avatar--Width: 2.25rem;\n  --pf-c-avatar--Height: 2.25rem;\n  width: var(--pf-c-avatar--Width);\n  height: var(--pf-c-avatar--Height);\n  border-radius: var(--pf-c-avatar--BorderRadius); }\n", ""]);

